import Button from "@mui/material/Button"
import { FormControlLabel, Grid2 as Grid, Switch } from "@mui/material"
import { Formik, Field } from "formik"
import { Fondo } from "../../types"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormikTextField } from "./formsHelpers"
import { FormInDialogEditProps } from "../DialogForm"
import { useTranslation } from "react-i18next"

export default function FondoFormNote({ item, save, ref, language }: FormInDialogEditProps<Fondo>) {
  const { t } = useTranslation()

  const schema = useMemo(
    () =>
      yup.object().shape({
        denominazione: yup.string().required().label(t("fondo.denominazione")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={item}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Fondo).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={values.rel_archivistiche}
                      onChange={(e) => setFieldValue("rel_archivistiche", e.target.checked)}
                    />
                  }
                  label={t("fondo.rel_archivistiche")}
                />
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="note_rel_archivistiche_it"
                    label={t("fondo.note_rel_archivistiche")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="note_rel_archivistiche_en"
                    label={t("fondo.note_rel_archivistiche_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="bibliografia_it"
                    label={t("fondo.bibliografia")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="bibliografia_en"
                    label={t("fondo.bibliografia_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>

              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="note_it"
                    label={t("fondo.note")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="note_en"
                    label={t("fondo.note_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
              <Grid size={12}>
                {language === "it" ? (
                  <Field
                    component={FormikTextField}
                    name="note_archivista_it"
                    label={t("fondo.note_archivista")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                ) : (
                  <Field
                    component={FormikTextField}
                    name="note_archivista_en"
                    label={t("fondo.note_archivista_en")}
                    required
                    margin="dense"
                    fullWidth
                    variant="outlined"
                    multiline
                    minRows={6}
                  />
                )}
              </Grid>
              <Grid size={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={values.documentazione_completa}
                      onChange={(e) => setFieldValue("documentazione_completa", e.target.checked)}
                    />
                  }
                  label={t("fondo.documentazione_completa")}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
